export default __webpack_public_path__ + "static/media/default-color-logo.075a655e.png";